import { AccountFeatures, AppContext } from "@lightspeed-invoicing/core-client/frontend"
import $ from "jquery"
import React, { Component } from "react"
import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import DeprecatedCustomerEmailSelect from "../../customer/emailselection.component.jsx"
import { isError } from "../../state/helpers/Error"
import LocationService from "../../state/location/LocationService"
import { PROPOSAL_TYPE } from "../../state/proposal/ProposalType"
import templateService from "../../state/template/TemplateService"
import { TYPE_MAIL } from "../../state/template/TemplateType"
import ActionButton from "../button/actionbutton.component.jsx"
import Icon from "../icon/icon.component.jsx"
import RichTextEditor from "../rich-text/editor.component.jsx"
import EmailSelection from "./emailselection.component.jsx"

const messages = defineMessages({
    button_label: {
        id: "send.email.modal.button_label",
        defaultMessage: "Open"
    },
    default_name: {
        id: "templates.default_template_name",
        defaultMessage: "Default template"
    }
})

class SendEmailModal extends Component {
    constructor(props, context) {
        super(props, context)

        let buttonLabel = this.props.intl.formatMessage(messages["button_label"])
        const isInvoice = this.props.proposalType === "invoice"
        const isAccountStatement = this.props.proposalType === "account-statement"
        this.state = {
            modalId: this.props.modalId || "send-proposal-email-modal",
            title: this.props.title || "",
            noEmail: this.props.noEmail || false,
            noToEmail: this.props.noToEmail || false,
            noCcEmail: this.props.noCcEmail || false,
            noModal: this.props.noModal || false,
            subject: this.props.subject || this.props.lastEmailSubject || "",
            content: this.removeLegacyProposalLink(this.props.content || this.props.lastEmailContent || ""),
            toEmail: this.props.toEmail ? (Array.isArray(this.props.toEmail) ? this.props.toEmail : [this.props.toEmail]) : [],
            ccEmail: this.props.ccEmail ? (Array.isArray(this.props.ccEmail) ? this.props.ccEmail : [this.props.ccEmail]) : [],
            bccEmail: this.props.bccEmail ? [this.props.bccEmail] : [],
            buttonLabel: this.props.buttonLabel || this.props.lastEmailButtonLabel,
            toEmailDescription: "",
            fromEmailDescription: "",
            isInvoice: isInvoice,
            isAccountStatement: isAccountStatement,
            pdfIncluded: false,
            templateKey: this.props.templateKey || "",
            templateId: this.props.templateId || "",
            isRecurringEmail: this.props.isRecurringEmail || false,
            ctaLabel: this.props.ctaLabel || <FormattedMessage id="common.send_email.modal.send_btn" defaultMessage="Send now" />,
            templatesList: [],
            selectedTemplate: "",
            selectedTemplateId: "",
            toEmailError: false,
            ccEmailError: false,
            bccEmailError: false,
            fromEmailError: false,
            fromEmail: this.props.fromEmail || [],
            locationId: this.props.locationId,
            fromName: "",
            hideDestinationAddress: this.props.hideDestinationAddress || false,
            hideMainButton: this.props.hideMainButton || false
        }
        if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
            this.state.toEmail = [AppContext.getUserLoggedIn().attributes.email]
            this.state.toEmailDescription = (
                <small className="form-text text-muted">
                    <span>
                        <Icon value="info" />
                        &nbsp;
                        <FormattedMessage
                            id="common.send_email.modal.to_override_description"
                            defaultMessage="We have put your email here so you can send yourself a test email"
                        />
                    </span>
                </small>
            )
        }
        AppContext.getApiClient()
            .get("/accounts/company-descriptions")
            .then(result => {
                this.setState({
                    companyEmail: result.attributes.organization.attributes.email
                })
            })

        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleRichTextChange = this.handleRichTextChange.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.sendEmail = this.sendEmail.bind(this)
        this.getTemplates = this.getTemplates.bind(this)
        this.setSelectedTemplate = this.setSelectedTemplate.bind(this)
        this.handleTemplateSelect = this.handleTemplateSelect.bind(this)
        this.setDefaultTemplatePerDocType = this.setDefaultTemplatePerDocType.bind(this)
        this.getLocation = this.getLocation.bind(this)
    }

    componentDidMount() {
        if (!this.state.noModal) {
            $("#" + this.state.modalId).modal("show")
        }

        if (this.state.locationId) {
            this.getLocation(this.state.locationId)
        }

        this.getTemplates()
    }

    async getLocation(locationId) {
        let location = await LocationService.getLocationById(locationId)
        if (location) {
            this.setDefaultTemplatePerDocType(location)
        }
    }

    setDefaultTemplatePerDocType(location) {
        let selectedTemplateId = ""
        let defaultTemplates = location.getDefaultTemplates()
        switch (this.props.proposalType) {
            case PROPOSAL_TYPE.INVOICE:
                selectedTemplateId = defaultTemplates.defaultInvoiceEmailTemplateId
                break
            case PROPOSAL_TYPE.QUOTE:
                selectedTemplateId = defaultTemplates.defaultQuoteEmailTemplateId
                break
            case PROPOSAL_TYPE.ORDER:
                selectedTemplateId = defaultTemplates.defaultOrderEmailTemplateId
                break
            case PROPOSAL_TYPE.CONTRACT:
                selectedTemplateId = defaultTemplates.defaultContractEmailTemplateId
                break
        }
        this.setState({ selectedTemplateId: selectedTemplateId })
    }

    getTemplates() {
        templateService.findAllTemplates(TYPE_MAIL, this.props.templateKey).then(templates => {
            if (!isError(templates)) {
                this.setState(
                    {
                        templatesList: templates
                    },
                    () => {
                        let templateIdToUse = null
                        if (this.state.templateId) {
                            templateIdToUse = this.state.templatesList.find(temp => temp.getId() === this.state.templateId)?.getId() ?? null
                        } else if (this.state.selectedTemplateId) {
                            templateIdToUse = this.state.selectedTemplateId
                        } else {
                            templateIdToUse = this.state.templatesList?.find(temp => temp.getStatus() === "default")?.getId() ?? null
                        }
                        this.setSelectedTemplate(templateIdToUse,true)
                    }
                )
            }
        })
    }

    setSelectedTemplate(selectedTemplateId, initialLoading) {
        if (!selectedTemplateId) {
            return
        }

        let selectedTemplate = this.state.templatesList.find(t => t.getId() == selectedTemplateId)
        if (!selectedTemplate) {
            return
        }

        let pdfIncluded = false
        if (this.state.isInvoice) {
            pdfIncluded =
                AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureIncludePdfAttachmentInInvoice) &&
                selectedTemplate.getAttachPdfByDefault()
        }

        if (this.state.isAccountStatement) {
            pdfIncluded =
                AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureAccountStatements) &&
                selectedTemplate.getAttachPdfByDefault()
        }

        let fromName =
            this.props.isCustomFromName && initialLoading
                ? this.props.fromName || selectedTemplate.getFromName()
                : selectedTemplate.getFromName() || this.props.fromName

        this.setState(
            {
                selectedTemplate: selectedTemplate,
                subject: initialLoading
                    ? this.state.subject || selectedTemplate.getSubject()
                    : selectedTemplate.getSubject() || this.state.subject,
                fromName: fromName,
                fromEmail:
                    !initialLoading && selectedTemplate.getFromEmail()
                        ? [selectedTemplate.getFromEmail()]
                        : this.state.fromEmail.length === 0 || (this.state.fromEmail.length === 1 && !this.state.fromEmail[0])
                            ? this.getDefaultEmail(selectedTemplate.getFromEmail())
                            : this.state.fromEmail,
                bccEmail: selectedTemplate.getDefaultBcc() ? [selectedTemplate.getDefaultBcc()] : [],
                content: initialLoading
                    ? this.state.content || selectedTemplate.getContent()
                    : selectedTemplate.getContent() || this.state.content,
                buttonLabel: initialLoading
                    ? this.state.buttonLabel || selectedTemplate.getButtonLabel()
                    : selectedTemplate.getButtonLabel() || this.state.buttonLabel,
                pdfIncluded: pdfIncluded
            },
            () => {
                if (this.state.fromEmail.length > 0) {
                    this.setState({
                        fromEmailError: false
                    })
                }
            }
        )
    }

    handleTemplateSelect(event) {
        this.setSelectedTemplate(this.state.templatesList[event].getId(), false)
    }

    getDefaultEmail(defaultEmail) {
        return defaultEmail ? (Array.isArray(defaultEmail.split(";")) ? defaultEmail.split(";") : [defaultEmail.split(";")]) : []
    }

    removeLegacyProposalLink(content) {
        return content
            .replace('<a href="{{.ProposalLink}}">Ouvrir la soumission</a>', "")
            .replace('<a href="{{.ProposalLink}}">Open proposal</a>', "")
    }

    closeModal(event) {
        event.preventDefault()
        if (this.props.onCloseWithoutSubmit) {
            this.props.onCloseWithoutSubmit(
                this.state.subject,
                this.state.toEmail.join(", "),
                this.state.ccEmail.join(", "),
                this.state.content,
                this.state.buttonLabel,
                this.state.pdfIncluded,
                this.state.fromEmail && this.state.fromEmail.length > 0 ? this.state.fromEmail[0] : "",
                this.state.bccEmail.join(", ")
            )
        }

        $("#" + this.state.modalId).modal("hide")
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    sendEmail(event) {
        event.preventDefault()
        if (this.props.onSubmit) {
            this.props.onSubmit(
                this.state.subject,
                this.state.toEmail.join(", "),
                this.state.ccEmail.join(", "),
                this.state.content,
                this.state.buttonLabel,
                this.state.pdfIncluded,
                this.state.templateKey,
                this.state.fromEmail ? this.state.fromEmail : "",
                this.state.bccEmail.join(", "),
                this.state.fromName
            )
        }
        this.closeModal(event)
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name

        this.setState({
            [name]: value
        })
    }

    handleRichTextChange(value) {
        this.setState({
            content: value
        })
    }

    render() {
        return (
            <form className="needs-validation" noValidate id="work-order-form-creation-modal">
                <div
                    className={this.state.noModal ? "" : "modal"}
                    id={this.state.modalId}
                    role="dialog"
                    aria-labelledby={this.state.modalId + "Label"}
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className={this.state.noModal ? "" : "modal-dialog modal-signature"} role="document">
                        <div className={this.state.noModal ? "" : "modal-content"}>
                            {!this.state.noModal ? (
                                <div className="modal-header">
                                    {!this.state.title ? (
                                        <div className="modal-title h5" id={this.modalId + "Label"}>
                                            {this.state.isRecurringEmail ? (
                                                <FormattedMessage
                                                    id="common.send_email.modal.title_recurring_email"
                                                    defaultMessage="Configure recurring email"
                                                />
                                            ) : (
                                                <FormattedMessage
                                                    id="common.send_email.modal.title"
                                                    defaultMessage="Send an email"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="modal-title h5" id={this.modalId + "Label"}>
                                            {this.state.title}
                                        </div>
                                    )}
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            ) : null}
                            <div className="modal-body">
                                <div className="container-fluid">
                                    {this.props.customFormElement && <> {this.props.customFormElement}</>}
                                    <div className="form-group row mb-1">
                                        <label className="col-2 col-form-label custom-form-label pb-2" htmlFor="subject">
                                            <FormattedMessage
                                                id="common.send_email.modal.subject_label"
                                                defaultMessage="Subject"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <input
                                                name="subject"
                                                value={this.state.subject}
                                                onChange={this.handleFormChange}
                                                id="subject"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mb-1">
                                        <label className="col-2 col-form-label custom-form-label pb-2" htmlFor="fromName">
                                            <FormattedMessage
                                                id="common.send_email.modal.from_name_label"
                                                defaultMessage="From name"
                                            />
                                        </label>
                                        <div className="col-10">
                                            <input
                                                name="fromName"
                                                value={this.state.fromName}
                                                onChange={this.handleFormChange}
                                                id="fromName"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    {this.state.fromEmail ? (
                                        <div className="form-group row mb-1">
                                            <label className="col-2 col-form-label custom-form-label pb-2" htmlFor="fromEmail">
                                                <FormattedMessage id="common.send_email.modal.from_label" defaultMessage="From" />
                                            </label>
                                            <div className="col-10">
                                                {!this.state.noEmail && this.state.fromEmailError && (
                                                    <div className="text-danger">
                                                        <small>
                                                            <FormattedMessage
                                                                id="common.send_email.modal.from_email_error"
                                                                defaultMessage="Select one of the emails provided"
                                                            />
                                                        </small>
                                                    </div>
                                                )}
                                                <EmailSelection
                                                    fromEmail={this.state.fromEmail}
                                                    locationId={this.state.locationId}
                                                    templateKey={this.state.templateKey}
                                                    onChange={(val, error) => {
                                                        this.setState({
                                                            fromEmail: val,
                                                            fromEmailError: error
                                                        })
                                                    }}
                                                />
                                                {this.state.fromEmailDescription}
                                            </div>
                                        </div>
                                    ) : null}
                                    {!this.state.noEmail && !this.state.noToEmail ? (
                                        <div className="form-group row mb-1">
                                            <label className="col-2 col-form-label custom-form-label pb-2" htmlFor="toEmail">
                                                <FormattedMessage id="common.send_email.modal.to_label" defaultMessage="To" />
                                            </label>
                                            <div className="col-10">
                                                {this.state.toEmailError && (
                                                    <div className="text-danger">
                                                        <small>
                                                            <FormattedMessage
                                                                id="common.send_email.modal.to_email_error"
                                                                defaultMessage="One or multiple emails are invalid"
                                                            />
                                                        </small>
                                                    </div>
                                                )}
                                                <DeprecatedCustomerEmailSelect
                                                    name="toEmail"
                                                    value={this.state.toEmail}
                                                    onChange={(val, error) => {
                                                        this.setState({
                                                            toEmail: val,
                                                            toEmailError: error
                                                        })
                                                    }}
                                                    id="toEmail"
                                                    type="text"
                                                    className="form-control"
                                                />
                                                {this.state.toEmailDescription}
                                            </div>
                                        </div>
                                    ) : null}
                                    {!this.state.noEmail && !this.state.noCcEmail ? (
                                        <div className="form-group row mb-0">
                                            <label className="col-2 col-form-label custom-form-label pb-2" htmlFor="ccEmail">
                                                <FormattedMessage id="common.send_email.modal.cc_label" defaultMessage="Cc" />
                                            </label>
                                            <div className="col-10">
                                                {this.state.ccEmailError && (
                                                    <div className="text-danger">
                                                        <small>
                                                            <FormattedMessage
                                                                id="common.send_email.modal.cc_email_error"
                                                                defaultMessage="One or multiple emails in CC are invalid"
                                                            />
                                                        </small>
                                                    </div>
                                                )}
                                                <DeprecatedCustomerEmailSelect
                                                    name="ccEmail"
                                                    value={this.state.ccEmail}
                                                    onChange={(val, error) => {
                                                        this.setState({
                                                            ccEmail: val,
                                                            ccEmailError: error
                                                        })
                                                    }}
                                                    id="ccEmail"
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                    {!this.state.noEmail && this.state.bccEmail ? (
                                        <div className="form-group row mb-0">
                                            <label className="col-2 col-form-label custom-form-label pb-2" htmlFor="bccEmail">
                                                <FormattedMessage id="common.send_email.modal.bcc_label" defaultMessage="Bcc" />
                                            </label>
                                            <div className="col-10">
                                                {this.state.bccEmailError && (
                                                    <div className="text-danger">
                                                        <small>
                                                            <FormattedMessage
                                                                id="common.send_email.modal.bcc_email_error"
                                                                defaultMessage="One or multiple emails in BCC are invalid"
                                                            />
                                                        </small>
                                                    </div>
                                                )}
                                                <DeprecatedCustomerEmailSelect
                                                    name="bccEmail"
                                                    value={this.state.bccEmail}
                                                    onChange={(val, error) => {
                                                        this.setState({
                                                            bccEmail: val,
                                                            bccEmailError: error
                                                        })
                                                    }}
                                                    id="bccEmail"
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="form-group row mb-0">
                                        <label className="col-12 col-form-label custom-form-label pb-2">
                                            <FormattedMessage
                                                id="common.send_email.modal.content_label"
                                                defaultMessage="Content"
                                            />
                                        </label>
                                        <div className="col-12">
                                            <RichTextEditor
                                                height={300}
                                                name="content"
                                                value={this.state.content}
                                                onChange={this.handleRichTextChange}
                                                id="content"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    {!this.state.hideMainButton && (
                                        <div className="form-group row mb-0 d-flex">
                                            <label className="col-form-label custom-form-label pb-2 px-3 " htmlFor="ccEmail">
                                                <FormattedMessage
                                                    id="common.send_email.modal.button_label"
                                                    defaultMessage="Button label"
                                                />
                                            </label>
                                            <div className="ml-2 flex-fill pr-3">
                                                <input
                                                    name="buttonLabel"
                                                    value={this.state.buttonLabel}
                                                    onChange={this.handleFormChange}
                                                    id="buttonLabel"
                                                    type="text"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {(AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureIncludePdfAttachmentInInvoice) &&
                                        this.state.isInvoice) ||
                                        (AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureAccountStatements) &&
                                            this.state.isAccountStatement) ? (
                                        <div className={"mb-1 form-group row mt-3"}>
                                            <div className="col-12">
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="pdfIncluded"
                                                        name="pdfIncluded"
                                                        onChange={this.handleFormChange}
                                                        checked={this.state.pdfIncluded}
                                                    />
                                                    <label className="custom-control-label" htmlFor="pdfIncluded">
                                                        <FormattedMessage
                                                            id="common.send_email.modal.include_pdf_attachment"
                                                            defaultMessage="Include Pdf attachment"
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary "
                                    onClick={this.closeModal}
                                    style={{ marginRight: "auto" }}
                                >
                                    <Icon value={"times"} className={"mr-1"} />
                                    <FormattedMessage id="common.send_email.modal.close_btn" defaultMessage="Close" />
                                </button>
                                {this.state.templateId === "" &&
                                    <DropdownButton
                                        as={ButtonGroup}
                                        onSelect={e => this.handleTemplateSelect(e)}
                                        title={
                                            this.state.selectedTemplate && this.state.selectedTemplate.getName()
                                                ? this.state.selectedTemplate.getName()
                                                : this.props.intl.formatMessage(messages["default_name"])
                                        }
                                    >
                                        {Object.entries(this.state.templatesList).map(([key, value]) => (
                                            <Dropdown.Item eventKey={key} value={value} className={"text-" + key}>
                                                {value.getName() || this.props.intl.formatMessage(messages["default_name"])}
                                            </Dropdown.Item>
                                        ))}
                                    </DropdownButton>
                                }

                                {!this.state.hideActionButton && (
                                    <div>
                                        <ActionButton
                                            onClick={this.sendEmail}
                                            className="btn btn-primary"
                                            disabled={
                                                !this.state.noEmail
                                                ? (!this.state.noToEmail && !this.state.noCcEmail ?  this.state.toEmail.length === 0 ||
                                                this.state.toEmailError ||
                                                this.state.ccEmailError || this.state.bccEmailError : this.state.bccEmailError)
                                                : false
                                            }
                                        >
                                            <Icon
                                                value={this.state.isRecurringEmail ? "check" : "paper-plane"}
                                                className={"mr-1"}
                                            />
                                            {this.state.ctaLabel}
                                        </ActionButton>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default injectIntl(SendEmailModal)



// WEBPACK FOOTER //
// ./src/common/email/sendemail.component.jsx